export interface IMARRIAGE_FORMULA {
  currentExpense: number;
  inflationRate: number;
  currentAge: number;
  marriageAge: number;
  returnRate: number;
  currentSavings: number;
}
export const MARRIAGE_FORMULA = ({
  currentExpense,
  inflationRate,
  currentAge,
  marriageAge,
  returnRate,
  currentSavings,
}: IMARRIAGE_FORMULA) => {
  if (
    currentExpense < 0 ||
    currentExpense > 1e12 ||
    inflationRate < 0 ||
    inflationRate > 40 ||
    currentAge < 0 ||
    currentAge > 100 ||
    marriageAge < 0 ||
    marriageAge > 100 ||
    currentSavings < 0 ||
    currentSavings > 1e11 ||
    currentAge > marriageAge
  ) {
    const res = 0;
    return {
      marriageCost: res.toFixed(0),
      investmentReq: res.toFixed(0),
      wealthyMessage: '',
    };
  }
  const expense = currentExpense;
  const inflation = inflationRate;
  const currAge = currentAge;
  const marrAge = marriageAge;
  const retRate = returnRate;
  const currSavings = currentSavings;
  const rate1 = retRate / 100;
  const rate2 = retRate / 1200;
  const ageDiff = marrAge - currAge;
  const a = 1 + inflation / 100;
  const marrCost = Math.round(expense * Math.pow(a, ageDiff));
  const ageDiffMonths = ageDiff * 12;
  let pow = Math.pow(1 + rate1, ageDiff);
  let fv;
  if (rate1 === 0) {
    fv = Math.round(currSavings);
  } else {
    fv = Math.round(currSavings * pow);
  }
  const balance = marrCost - fv;
  let pmt;
  pow = Math.pow(1 + rate2, ageDiffMonths);
  if (rate2 === 0) {
    pmt = balance / ageDiffMonths;
  } else {
    pmt = (-rate2 * balance) / (pow - 1);
  }
  const payments = -Math.round(pmt);
  return {
    marriageCost: marrCost.toFixed(2),
    investmentReq: payments > 0 ? payments.toFixed(2) : '0.00',
    wealthyMessage:
      payments > 0
        ? ''
        : `You're Doing Well. You've Enough Wealth To Meet Your Child's Marriage Expenses. Continue Your Investment In Mutual Fund`,
  };
};
